import axios from 'axios';
import {initActionImportLunchMeals, initFileImportUpload} from './foodilo/import';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { initAjaxModal } from './foodilo/ajaxModal';

initAjaxModal({
    onResponse: (resp) => {
        // Tu daj svoju pôvodnú callbackAjaxResponse logiku
        // napr. callbackAjaxResponse(resp, resp.request, textStatus, jqXHR);
        console.log('AJAX response:', resp);
    },
    // voliteľne si zmeň selektory ak máš iné ID/štruktúru
    headerSel: '#dynamic-modal-header',
    titleSel:  '#dynamic-modal-title',
    submitBtnSel: '#dynamic-modal-submit-button',
    outputSel: '#dynamic-modal-output',
    loaderSel: '#content-loader-overlay',
    formSel:   '#common-modal-form',
    modalDialogSel: '.modal-dialog',
});

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

try {    // Base js localization
    i18next
        .use(LanguageDetector)
        .init({
            fallbackLng: 'sk',
            debug: false,
            resources: {}, // necháme prázdne, načítame dynamicky
        }, function (err, t) {
            loadLanguage(i18next.language || 'sk');
        }).then(r => {
            console.log("i18next is initialized");
        });
    window.i18next = i18next;
}
catch (e) {
    console.log(i18next.t("Install required libraries!"));
}

function loadLanguage(lang: string | undefined) {
    fetch(`/assets/locales/${lang}.json`)
        .then(res => res.json())
        .then(data => {
            if (lang != null) {
                i18next.addResourceBundle(lang, 'translation', data, true, true);
            }
        })
        .catch(() => {
            console.error(`Nepodarilo sa načítať preklady pre jazyk: ${lang}`);
        });
}

// Spusti len ak sme na stránke s uploader (napr. podľa ID elementu)
document.addEventListener("DOMContentLoaded", () => {
    const uploader = document.getElementById('lunch-menu-import-uploader');
    if (uploader instanceof HTMLInputElement) {
        console.log('[Foodilo] ✅ Našiel som uploader, spúšťam import...');
        initFileImportUpload();
        initActionImportLunchMeals();
    }
});
